import * as ko from "knockout";
import Bao from "./../../services/bao-service";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-searcher";
function ExpandedSearchCustomer(parent) {
    var self = this;
    var htmlUrl = "ExpandedSearchSynoset/ExpandedCustomer";
    self.LoadHtml = function () {
        return Bao.get(htmlUrl, function (result) {
            Bao.Templates[htmlUrl] = result;
            parent.ExpandedSearchTemplateName(htmlUrl);
        });
    };
    self.ConfigurationItemTypeName = ko.observable();
    self.ConfigurationItemTypeId = ko.observable();
    self.ConfigurationItemTypeId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.ConfigurationItemStatusName = ko.observable();
    self.ConfigurationItemStatusId = ko.observable();
    self.ConfigurationItemStatusId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.GetCustomFilter = function () {
        if (self.ConfigurationItemTypeId() == null && self.ConfigurationItemStatusId() == null) {
            return null;
        }
        else {
            return {
                ConfigurationItemTypeId: JSON.stringify(self.ConfigurationItemTypeId()),
                ConfigurationItemStatusId: JSON.stringify(self.ConfigurationItemStatusId())
            };
        }
    };
    self.init = function () {
        return self.LoadHtml();
    };
}
export default ExpandedSearchCustomer;